module.exports = __webpack_public_path__ + "img/icon_6th.4ca094ef.png";